import React from 'react';
import '../App.css';
import NavBar from '../components/NavBar';

function Units() {
    return (
        <>  
            <div className='h1'>
            <h1>Units</h1>
            </div>
            <div className='parent'>
                <div className='child'>
                    <label>
                        Add Unit: 
                    </label>
                    <select name="property_id" id="dropdown">
                        <option value="property_id">Property ID*</option>
                        <option value="000001">000001</option>
                        <option value="000002">000002</option>
                        <option value="000003">000003</option>
                    </select>
                    <input type="text" placeholder="Unit Number*" />
                    <input type="text" placeholder="Bedrooms*" />
                    <input type="text" placeholder="Bathrooms*" />
                    <input type="text" placeholder="Monthly Rent" />
                    <input type="submit" value="Submit" />
                    <div className='center-note'>
                        <p>* indicates a required field.</p>
                    </div>
                </div>
                <br></br>
                <div>
                    <label>
                        Search Units: 
                    </label>
                    <input type="text" placeholder="Property ID" />
                    <input type="text" placeholder="Unit Number" />
                    <input type="text" placeholder="Bedrooms" />
                    <input type="text" placeholder="Bathrooms" />
                    <input type="text" placeholder="Monthly Rent" />
                    <input type="submit" value="Submit" />
                </div>
            </div>
            <table id="customers" className='center-table'>
                <tr>
                    <th>Unit ID</th>
                    <th>Property ID</th>
                    <th>Street Address</th>
                    <th>Unit #</th>
                    <th>Bedrooms</th>
                    <th>Bathrooms</th>
                    <th>Monthly Rent</th>
                    <th></th>
                </tr>
                <tr>
                    <td>000001</td>
                    <td>000001</td>
                    <td>123 Main St.</td>
                    <td>1</td>
                    <td>2</td>
                    <td>1</td>
                    <td>$1500</td>
                    <td><button>Edit</button></td>
                </tr>
                <tr>
                    <td>000002</td>
                    <td>000001</td>
                    <td>123 Main St.</td>
                    <td>2</td>
                    <td>2</td>
                    <td>1.5</td>
                    <td>$1700</td>
                    <td><button>Edit</button></td>
                </tr>
                <tr>
                    <td>000003</td>
                    <td>000002</td>
                    <td>455 16th St.</td>
                    <td>A</td>
                    <td>1</td>
                    <td>1</td>
                    <td>$1200</td>
                    <td><button>Edit</button></td>
                </tr>
                <tr>
                    <td>000004</td>
                    <td>000002</td>
                    <td>455 16th St.</td>
                    <td>B</td>
                    <td>1</td>
                    <td>1</td>
                    <td>$1200</td>
                    <td><button>Edit</button></td>
                </tr>
                <tr>
                    <td>000005</td>
                    <td>000002</td>
                    <td>455 16th St.</td>
                    <td>C</td>
                    <td>0</td>
                    <td>1</td>
                    <td>$1050</td>
                    <td><button>Edit</button></td>
                </tr>
            </table>
            <br></br>

            <div>
                <NavBar/>
            </div>
        </>
    );
}

export default Units;